function find(needle) {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return userAgent.indexOf(needle) !== -1;
}

function isDeviceWindows() {
  return find('windows');
}

function isDeviceAndroid() {
  return !isDeviceWindows() && find('android');
}

function isDeviceiPhone() {
  return !isDeviceWindows() && find('iphone');
}

function checkIfDeviceIsMobile() {
  return isDeviceAndroid() || isDeviceiPhone();
}

export {
  isDeviceWindows,
  isDeviceAndroid,
  isDeviceiPhone,
  checkIfDeviceIsMobile,
};
